import PriceCell from 'components/ServicesTables/common/cells/PriceCell';
import TextCell from 'components/ServicesTables/common/cells/TextCell';
import { translate } from 'components/Translation';
import React, { useMemo } from 'react';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';

interface IInternationalMinutesColumnProps {
	catalogEntryView: types.ecommerce.CatalogEntryView;
}

const InternationalMinutesColumn = ({ catalogEntryView }: IInternationalMinutesColumnProps) => {
	const prices = catalogEntryView?.price || [];
	const attributes = catalogEntryView?.attributes || [];

	const price = useMemo(() => {
		return {
			offer: prices.find((singlePrice) => singlePrice.usage === 'Offer'),
			display: prices.find((singlePrice) => singlePrice.usage === 'Display'),
		};
	}, [prices]);

	const autoRenewal = useMemo(() => {
		const value = extractAttributeValue({ attributes }, CustomAttribute.RENEWAL);
		if (value === 'AUTO') {
			return translate('number.services.international.with.auto.renewal');
		}
	}, [attributes]);

	return (
		<>
			{autoRenewal && <TextCell text={autoRenewal} backgroundColor="backgroundGray" minHeight={60} />}
			<PriceCell
				price={price?.display.value || '-'}
				currency={price?.display.currency || ''}
				offerPrice={price.offer}
			/>
		</>
	);
};

export default InternationalMinutesColumn;
